<template>
    <div class="CardOperationsSeeContent CardReaderSubComponent">
        <div class="CardOperationsSeeContent-validationContainer">
            <icomoon-icon
                :name="'Check'"
                class="CardOperationsSeeContent-icon"
            />
            <div
                class="CardReaderSubComponent-title"
                v-text="$t('card_reader:update_card:load:success:message')"
            />
        </div>
        <v-btn
            class="CardReaderSubComponent-button"
            color="primary"
            variant="flat"
            @click="seeCardContent"
        >
            {{ $t('card_reader:see_card_content_button_text') }}
        </v-btn>
    </div>
</template>

<script setup>
import IcomoonIcon from '@/StoreWeb/components/common/IcomoonIcon'

const emit = defineEmits(['seeCardContent'])

function seeCardContent () {
    emit('seeCardContent')
}
</script>

<style lang="scss" scoped>
@import 'globalScss';

.CardOperationsSeeContent {
    gap: $s4;

    &-validationContainer {
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: $s4;
        opacity: 0;
        transform: scale(2);
        animation: animation-validation 3s forwards;
    }

    &-icon {
        display: block;
        font-size: 64px;
        color: $color-success;
    }
}

@keyframes animation-validation {
    0% {
        opacity: 0;
        transform: scale(2);
    }

    50% {
        opacity: 1;
        transform: scale(1);
    }

    100% {
        opacity: 1;
        transform: scale(1);
    }
}
</style>
